import { Radio } from "antd"
import { convertTo12Hr } from "../utils"

type ClockingCardProps = {
  value: number
  title: string
  clockIn: string
  clockOut: string
  onClick?: () => void
}
export const ClockingCard: React.FC<ClockingCardProps> = ({
  value,
  title,
  clockIn,
  clockOut,
  onClick,
}) => {
  return (
    <div
      className="bg-white rounded-md p-3 border border-slate-200 w-full flex flex-col gap-2 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center gap-1 justify-between">
        <p className="text-sm font-bold">{title}</p>
        <Radio value={value} />
      </div>
      <span className="flex items-center gap-2">
        <div className="border-l-[1.48px] border-l-slate-400 h-[13px] self-center"></div>
        <span className="text-sm text-slate-400">
          {convertTo12Hr(clockIn)} to {convertTo12Hr(clockOut)}
        </span>
      </span>
    </div>
  )
}
